<div class="latest-news-row pt-5 pb-5" id="latest-news">
    <div class="container">
        <div class="text-center ps-5 pe-5 res-plr-0">
            <h2 class="mb-3">News</h2>
            <p class="sub-text">Stay updated with our latest news, activities and case studies.</p>
        </div>

        <div class="row pt-4">
            <div class="col-lg-6">
                <div class="card">
                    <img class="card-img-top img-fluid" src="../assets/images/latest-news.jpg" alt="news-large-img">
                    <div class="card-body">
                        <h5 class="card-title">An unconventional charter solution amidst crisis</h5>
                        <p class="card-text">In the spring of 2020, air freight capacity was severely limited with the spread of 
                            Covid19 as nearly all passenger routes were canceled, scheduled freighter capacity was fully booked, and even chartering of full freighters was impossible due to huge volumes of PPE’s holding all capacity.
                        </p>
                        <a routerLink="/an-unconventional-charter-solution" class="more-link">More</a>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 horizontal-cards">

                <!-- <iframe src="https://feed.mikle.com/widget/v2/135937/?preloader-text=Loading" height="534px" width="100%" class="fw-iframe" scrolling="no" frameborder="0"></iframe> -->
                <!-- <iframe width="600" height="700" src="https://rss.app/embed/v1/Zb4dq8OjFqN9on5U" frameBorder="0"></iframe> -->
                <!-- <iframe width="600" height="700" src="https://rss.app/embed/v1/K7Tawp6WuOGNVPWA" frameBorder="0"></iframe> -->
                <!-- <iframe width="100%" height="510" src="https://rss.app/embed/v1/D7O6BYWw3FwVlrAD" frameBorder="0"></iframe> -->
                <!-- <iframe width="100%" height="510" src="https://rss.app/embed/v1/n3cWc5WgjLyWMmkh" frameBorder="0"></iframe> -->
                <!-- <iframe width="100%" height="510" src="https://rss.app/embed/v1/ic240LXaypDRmgO2" frameBorder="0"></iframe> -->
                <!-- <iframe width="100%" height="510" src="https://rss.app/embed/v1/lLzuJLlmh0Qj5wv6" frameBorder="0"></iframe> -->
                <iframe width="100%" height="510" src="https://rss.app/embed/v1/SIa4RzzRlzdCb8nJ" frameBorder="0"></iframe>
            </div>
        </div>
    </div>
</div>